import { useContentfulFetch } from '@/composables/useContentfulFetch'

export const useHomePage = async () => {
  const { locale } = useI18n()

  const key = `page-home-${locale.value}`

  const { data } = await useAsyncData(
    key,
    async () => {
      try {
        const [content, articles, videocasts] = await Promise.all([
          useContentfulFetch({
            url: '/api/v1/contentful/content',
            query: {
              contentModelOptions: {
                adapter: 'pageData',
                route: '/',
              },
            },
          }),
          $fetch('/api/v1/contentful/articles', {
            query: { locale: locale.value },
          }),
          $fetch('/api/v1/contentful/videocasts', {
            query: { locale: locale.value },
          }),
        ])

        const articlesElements = articles?.articles ?? []
        const videocastsElements = videocasts?.videocasts ?? []

        const elements = [...articlesElements, ...videocastsElements].sort(
          (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
        )

        return {
          content,
          articles,
          videocasts,
          elements,
        }
      } catch (e) {
        console.error(e)
        return {
          content: null,
          articles: [],
          videocasts: [],
          elements: [],
        }
      }
    },
  )

  return {
    data,
    content: computed(() => data.value?.content ?? null),
    articles: computed(() => data.value?.articles ?? []),
    videocasts: computed(() => data.value?.videocasts ?? []),
    elements: computed(() => data.value?.elements ?? []),
  }
}
